import React from 'react';

const SetInitialFocusContext = React.createContext(false);

export const SetInitialFocusProvider = SetInitialFocusContext.Provider;
export default SetInitialFocusContext;
